module.exports = __webpack_public_path__ + "static/img/icomoon.db3fb69b.svg";